export const snake2Camel = x => x.replace(/_(\w)/g, (_, c) => c.toUpperCase());
export const camel2Snake = x => x.replace(/[A-Z]/g, c => `_${c.toLowerCase()}`);
